import {
  // AnalyticsIcon,
  BonusesIcon,
  // DashboardIcon,
  FarmingIcon,
  // HomeIcon,
  LiquidityIcon,
  PoolsIcon,
  SupportIcon,
  SyncAltIcon,
  // UserPlusIcon,
} from '@nominex/dex-uikit'
import { ContextApi } from 'contexts/Localization/types'

type MenuItemsType = {
  label: string
  href: string
  IconComponent?: any
}

export const menuItemsConfig: (t: ContextApi['t']) => MenuItemsType[] = (t) => [
  // {
  //   label: t('Home'),
  //   href: '/',
  //   IconComponent: HomeIcon,
  // },
  // {
  //   label: t('Dashboard'),
  //   href: '/dashboard',
  //   IconComponent: DashboardIcon,
  // },
  {
    label: t('Swap'),
    href: '/swap',
    IconComponent: SyncAltIcon,
  },
  {
    label: t('Liquidity'),
    href: '/liquidity',
    IconComponent: LiquidityIcon,
  },
  {
    label: t('Farms'),
    href: '/farms',
    IconComponent: FarmingIcon,
  },
  {
    label: t('Launchpools'),
    href: '/pools',
    IconComponent: PoolsIcon,
  },
  // {
  //   label: t('Referral program'),
  //   href: '/referrals',
  //   IconComponent: UserPlusIcon,
  // },
  {
    label: t('Rewards'),
    href: '/bonuses',
    IconComponent: BonusesIcon,
  },
  {
    label: t('Community'),
    href: '/support',
    IconComponent: SupportIcon,
  },
]

export const WIDTH = 260
export const COLLAPSED_WIDTH = 82
